import React from 'react';
import './Views.css';
import fetchViewsForPage from '../../../api/fetchViewsForPage';
import { withRouter} from 'react-router-dom';
import Cookie from 'js-cookie';

class Views extends React.Component {
  state={
    currentPageViews: 0,
  }

  updateNumOfViews = (currentPage) => {
    const page = currentPage === "/" ? "kongihome" : "kongi"+currentPage.substring(1);
    //if viewed the page set cookie to avoid count the view again
    if(Cookie.get(page) !== "true") {
      fetchViewsForPage(page, 'PUT')
      .then(res => {
        if(res.status === 200)
          this.setState({
            currentPageViews: res.view.numOfViews,
          })
        Cookie.set(page, "true");  
      });
    }else {
      fetchViewsForPage(page, 'GET')  
      .then(res => {
        if(res.status === 200)
          this.setState({
            currentPageViews: res.view.numOfViews,
          })
      });     
    }
  }

  componentDidMount() {
    this.updateNumOfViews(this.props.location.pathname);
    //when path changed show current page number of views
    this.props.history.listen(location => {
      if(location.pathname !== this.props.location.pathname)
        this.updateNumOfViews(location.pathname);
    })
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    }
  }

  render() {
    return (
      <React.Fragment>
        <h5>Views</h5>
        <div className="views-info">{this.state.currentPageViews}</div>
      </React.Fragment>
    )
  }
}

export default withRouter(Views);